module.exports = __webpack_public_path__ + "img/Altruvest Full Logo - Blue Text.b9b2c4c5.svg";